import fuzzyLogicSoilAttribute from './fuzzyLogicSoilAttribute';

export const MECH_SITE_PREP_SURFACE = fuzzyLogicSoilAttribute({
  fuzzyLogicRuleName: 'FOR - Mechanical Site Preparation (Surface)',
  key: 'Mechanical Site Preparation (Surface)',
  ruleId: '36',
  shortFormData: { AggregationMethod: 'Dominant Condition' },
});
